'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'desktop';
var width = 512;
var height = 512;
var aliases = [128421,61704,"desktop-alt"];
var unicode = 'f390';
var svgPathData = ['M32 96l0 192 448 0 0-192c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96zM202.9 480l106.2 0-10.7-64-84.9 0-10.7 64z', 'M448 64L64 64C46.3 64 32 78.3 32 96l0 192 448 0 0-192c0-17.7-14.3-32-32-32zm32 256l-448 0 0 32c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-32zM64 32l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-117.1 0 10.7 64 58.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l58.4 0 10.7-64-117.1 0c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32zM213.6 416l-10.7 64 106.2 0-10.7-64-84.9 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDesktop = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;